module.exports = __webpack_public_path__ + "img/compassionate-carer.92892b03.svg";